import { Provider } from '@angular/core';
import { ɵStateClass } from '@ngxs/store/internals';
import { AccountEffects } from './account/account.effects';
import { AccountSnapshot } from './account/account.snapshot';
import { AccountState } from './account/account.state';

export const CORE_STATES: ɵStateClass[] = [AccountState];

export const CORE_STATE_EFFECTS: Provider[] = [AccountEffects];

export const CORE_STATE_HELPERS: Provider[] = [AccountSnapshot];
